export const callsInterval = 20000;
export const bdbsCallInterval = 10000;
export const bdbsProgressCallInterval = 2000;
export const bdbUpgradeStatusCallInterval = 1000;
export const planCallsInterval = process.env.NODE_ENV === 'test' ? 0 : 3000;
